export default __webpack_public_path__ + "static/media/allLove.d8ad4714.png";